import * as tslib_1 from "tslib";
import { UiForm } from './../ui';
var NodeForm = (function (_super) {
    tslib_1.__extends(NodeForm, _super);
    function NodeForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NodeForm.prototype.materializeViewParam = function (view, param, stack, factory) {
        return _super.prototype.materializeViewParam.call(this, view, param, stack, factory);
    };
    NodeForm.prototype.materializeModelParam = function (model, param, stack, factory) {
        return _super.prototype.materializeModelParam.call(this, model, param, stack, factory);
    };
    return NodeForm;
}(UiForm));
export { NodeForm };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm9kZS1mb3JtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibm9kZS1mb3JtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFDQSxPQUFPLEVBQUMsTUFBTSxFQUFDLE1BQU0sU0FBUyxDQUFDO0FBTS9CO0lBQXVHLG9DQUFZO0lBQW5IOztJQVFBLENBQUM7SUFQQyx1Q0FBb0IsR0FBcEIsVUFBcUIsSUFBTyxFQUFFLEtBQVcsRUFBRSxLQUFnQixFQUFFLE9BQWU7UUFDMUUsTUFBTSxDQUFDLGlCQUFNLG9CQUFvQixZQUFDLElBQUksRUFBRSxLQUFLLEVBQUUsS0FBSyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0lBQ2pFLENBQUM7SUFFRCx3Q0FBcUIsR0FBckIsVUFBc0IsS0FBUSxFQUFFLEtBQVcsRUFBRSxLQUFnQixFQUFFLE9BQWU7UUFDNUUsTUFBTSxDQUFDLGlCQUFNLHFCQUFxQixZQUFDLEtBQUssRUFBRSxLQUFLLEVBQUUsS0FBSyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0lBQ25FLENBQUM7SUFDSCxlQUFDO0FBQUQsQ0FBQyxBQVJELENBQXVHLE1BQU0sR0FRNUcifQ==